import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import StaticSearch from 'Containers/StaticSearch/StaticSearch';
import { fetchTrendingDeals } from 'Redux/ducks/algolia-calls';

const messages = defineMessages({
  title: {
    id: 'trendingdeals.title',
    defaultMessage: 'Popular Games',
  },
  fullTitle: {
    id: 'trendingdeals.seotitle',
    defaultMessage: 'Popular Games | Best Prices on PC and Steam Games',
  },
  desc: {
    id: 'trendingdeals.seodesc',
    defaultMessage: 'These are the hottest games that are selling fast, whether it\'s a brand new title, or a really great deal.',
  },
  pcGameDeals: {
    id: 'trendingdeals.pcgamedeals',
    defaultMessage: 'PC Game Deals',
  },
});

export default function TrendingDeals() {
  const { formatMessage } = useIntl();

  const crumbs = [{
    label: formatMessage(messages.pcGameDeals),
    link: '/on-sale/',
  },
  {
    label: formatMessage(messages.title),
    link: '/trending-deals',
  },
  ];

  return (<StaticSearch
    updateHits={fetchTrendingDeals}
    url="trending-deals"
    seoBlurb={messages.desc}
    crumbs={crumbs}
    {...messages}
  />);
}
